import { Platform } from 'react-native';
import { Action, Output, } from '@zattoo/taf-protobuf/protobuf/action';
import { EventKey as SocketEventKey, Socket, } from './socket-adapter';
import { zapiCreate, zapiSessionHello, zapiSignIn, } from './actions';
export var EventKey;
(function (EventKey) {
    EventKey["NewSession"] = "NEW_SESSION";
    EventKey["PlayerCreated"] = "PLAYER_CREATED";
    EventKey["PlayerDestroyed"] = "PLAYER_DESTROYED";
})(EventKey || (EventKey = {}));
export class TafAdapterBase {
    socket;
    session = null;
    listeners = new Map();
    constructor(configuration) {
        this.socket = new Socket(configuration);
        this.socket.addEventListener(SocketEventKey.Ready, this.onSocketReady);
        // @ts-expect-error incomplete types
        this.socket.addEventListener(SocketEventKey.Message, this.onSocketMessage);
        this.socket.addEventListener(SocketEventKey.Close, this.onSocketClose);
    }
    onSocketReady = () => {
        const deviceInfo = Output.create({
            deviceInfo: {
                name: 'Some device',
                id: 'some uuid',
                platform: Platform.OS,
            },
        });
        this.dispatchOutput(deviceInfo);
    };
    onSocketMessage = async (event) => {
        await this.handleSocketMessage(event.detail);
    };
    onSocketClose = () => {
        this.setSession(null);
    };
    async handleSocketMessage(data) {
        const action = Action.decode(data);
        let output;
        try {
            const result = await this.handle(action);
            if (!result) {
                output = Output.create({
                    actionResult: {
                        id: action.id,
                        success: true,
                    },
                });
            }
            else {
                output = Output.create({
                    actionResult: {
                        id: action.id,
                        success: true,
                        ...result,
                    },
                });
            }
        }
        catch (error) {
            console.error(error);
            output = Output.create({
                actionResult: {
                    id: action.id,
                    success: false,
                    error: `${error}`,
                },
            });
        }
        this.dispatchOutput(output);
    }
    dispatchOutput(output) {
        const encodedData = Output.encode(output).finish();
        this.socket.send(encodedData);
    }
    getSession() {
        return this.session;
    }
    setSession(session) {
        this.session = session;
        this.dispatchEvent(EventKey.NewSession, session);
    }
    dispatchEvent(key, data) {
        const eventListeners = this.listeners.get(key);
        if (eventListeners) {
            eventListeners.forEach((listener) => listener({
                type: key,
                detail: data,
            }));
        }
    }
    addEventListener(type, listener) {
        if (!this.listeners.has(type)) {
            this.listeners.set(type, new Map());
        }
        this.listeners.get(type)?.set(listener, listener);
    }
    removeEventListener(type, listener) {
        const eventListeners = this.listeners.get(type);
        if (eventListeners) {
            eventListeners.delete(listener);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    decodeAction(action) {
        const actionKey = Object.entries(action)
            .filter(([_actionKey, _actionData]) => _actionData !== undefined && _actionKey !== 'id')
            .pop()?.[0];
        if (!actionKey) {
            return null;
        }
        const actionValue = action[actionKey];
        if (actionValue === null) {
            return null;
        }
        return {
            actionKey,
            actionValue,
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    tafCleanupSession() {
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    tafStartSession() {
    }
    handleTafAction(src, action) {
        const decoded = this.decodeAction(action);
        if (!decoded) {
            return Promise.resolve();
        }
        const { actionKey, } = decoded;
        switch (actionKey) {
            case 'cleanupSession':
                this.tafCleanupSession();
                break;
            case 'startSession':
                this.tafStartSession();
                break;
            case 'setVariant':
                break;
            default:
                console.error('Unsupported action', src, src.id);
                throw new Error(`Unsupported action ${JSON.stringify(action)}`);
        }
        return Promise.resolve();
    }
    async handleZapiAction(src, action) {
        const decoded = this.decodeAction(action);
        if (!decoded) {
            return Promise.resolve();
        }
        const { actionKey, actionValue, } = decoded;
        switch (actionKey) {
            case 'create':
                zapiCreate(actionValue);
                break;
            case 'sessionHello':
                await zapiSessionHello(actionValue);
                break;
            case 'signIn':
                await zapiSignIn(actionValue);
                break;
            default:
                console.error('Unsupported action', src, src.id);
                throw new Error(`Unsupported action ${JSON.stringify(action)}`);
        }
        return Promise.resolve();
    }
    async handle(action) {
        const decoded = this.decodeAction(action);
        if (!decoded) {
            return Promise.resolve();
        }
        const { actionKey, actionValue, } = decoded;
        switch (actionKey) {
            case 'session':
                this.setSession(actionValue);
                break;
            case 'taf':
                await this.handleTafAction(action, actionValue);
                break;
            case 'zapi':
                await this.handleZapiAction(action, actionValue);
                break;
            default:
                console.log('Unsupported action', action, action.id);
                throw new Error(`Unsupported action ${JSON.stringify(action)}`);
        }
        return Promise.resolve();
    }
}
